import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { Calendar } from "lucide-react";

export default function News() {
  const { t } = useI18n();
  const [news, setNews] = useState([]);
  useEffect(() => { api.get("/news").then(r => setNews(r.data)).catch(() => {}); }, []);

  const renderMedia = (n) => {
    if (!n.media_url) {
      return <div className="h-48 bg-gradient-to-br from-warm-orange to-gold"></div>;
    }
    if (n.media_type === "video") {
      return (
        <video
          src={n.media_url}
          controls
          preload="metadata"
          className="w-full h-48 object-cover bg-black"
          data-testid={`news-video-${n.id}`}
        />
      );
    }
    return (
      <img
        src={n.media_url}
        alt={n.title || ""}
        className="w-full h-48 object-cover"
        data-testid={`news-image-${n.id}`}
        loading="lazy"
      />
    );
  };

  return (
    <div data-testid="news-page">
      <section className="hero-gradient py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-warm-orange font-semibold">{t("pages.news.tag")}</div>
          <h1 className="font-display text-deep-blue text-5xl sm:text-6xl lg:text-7xl leading-tight mt-3">{t("pages.news.t1")}<br/><span className="italic text-warm-orange">{t("pages.news.t2")}</span></h1>
        </div>
      </section>
      <section className="py-16 bg-ivory">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          {news.length === 0 ? (
            <div className="p-12 rounded-2xl bg-pearl text-center">
              <p className="font-display text-2xl text-deep-blue">{t("news.empty1")}</p>
              <p className="text-deep-blue/60 mt-2">{t("news.empty2")}</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {news.map(n => (
                <article key={n.id} className="card-elev rounded-2xl overflow-hidden" data-testid={`news-${n.id}`}>
                  {renderMedia(n)}
                  <div className="p-6">
                    <div className="text-xs uppercase text-warm-orange tracking-widest">{n.category || t("news.category")}</div>
                    <h3 className="font-display text-xl text-deep-blue mt-2">{n.title}</h3>
                    <div className="text-xs text-deep-blue/60 mt-2 flex items-center gap-1"><Calendar size={12}/>{n.date}</div>
                    <p className="text-sm text-deep-blue/70 mt-3 whitespace-pre-line">{n.content?.slice(0,300)}{n.content?.length > 300 ? "…" : ""}</p>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
